import { render, staticRenderFns } from "./WapPlatformIntroduction.vue?vue&type=template&id=5f40c082&scoped=true&"
import script from "./WapPlatformIntroduction.vue?vue&type=script&lang=js&"
export * from "./WapPlatformIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./WapPlatformIntroduction.vue?vue&type=style&index=0&id=5f40c082&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f40c082",
  null
  
)

export default component.exports